<!--https://github.com/startbootstrap/startbootstrap-landing-page-->
<!-- Masthead-->
<header class="masthead text-white text-center">
   <div class="container">
      <div class="row">
         <div class="col-xl-9 mx-auto text-center">
            <img alt="Southwestern Family of Companies - Company Stock Plan" class="mx-auto d-block header-image"
                 src="/assets/images/southwestern-logo-white.png">
            <h1 class="mt-3 mb-5 text-center">Company Stock Plan</h1>
         </div>
      </div>
      @if ((isAdminOnlyMode$ | async) === false) {
         <div class="row">
            <div class="col-xl-9 mx-auto">
               <h5 class="mb-5 text-center">
                  User: <em>{{userProfile.displayName}}</em>
               </h5>
            </div>
            @if (userProfile.isAuthorized) {
               <div class="col-md-10 col-lg-8 col-xl-7 mx-auto">
                  <form (ngSubmit)="viewStockPlan()">
                     <div class="form-row">
                        <div class="col-12 col-md-7 mb-2 mb-md-0">
                           <input class="form-control form-control-lg text-center" type="password"
                                  placeholder="Enter the last 4 digits of your SSN..."
                                  [(ngModel)]="pin"
                                  [ngModelOptions]="{standalone: true}"
                                  pattern="^\d{4}$"
                                  maxlength="4"
                                  #pinInput="ngModel"
                                  required />
                        </div>
                        <div class="col-12 col-md-5">
                           <button class="btn btn-block btn-lg btn-site-primary"
                                   type="submit"
                                   [disabled]="pinInput.invalid">
                              View Stock Summary
                           </button>
                        </div>
                     </div>
                  </form>
               </div>
               <div class="col-xl-9 mx-auto mt-3">
                  <button type="button" class="btn btn-sm btn-site-primary" (click)="showSSNInfoModal()">
                     No SSN? - Click Here
                  </button>
               </div>
               <div class="col-xl-9 mx-auto mt-3">
                  Any questions regarding your plan?<br />Contact <a href="mailto:cjohnstone@southwestern.com?subject=SWFC Company Stock Plan">Cindy Johnstone</a>.
               </div>
               <div class="col-xl-9 mx-auto mt-4">
                  <em>
                     * For more information about the stock plan please see our Shareholder Services page on the Intranet
                     <a href="https://southwesternfamily.sharepoint.com/sites/intranet/SitePages/Shareholder-Services.aspx" target="_blank">HERE</a>.
                  </em>
               </div>
            } @else {
               <h4 class="col-xl-9 col-lg-8 col-md-10 mx-auto mt-2">
                  You are not currently set up as a shareholder for the<br />SWFC Corporate Stock site.<br /><br />
                  If you have any questions regarding this,
                  Please contact <a href="mailto:cjohnstone@southwestern.com?subject=SWFC Company Stock Plan">Cindy Johnstone</a>
               </h4>
            }
         </div>
      }

      @if (isAdminOnlyMode$ | async) {
         <div class="row">
            <h4 class="col-xl-9 col-lg-8 col-md-10 mx-auto mt-2">
               This site is currently offline.<br /><br />Check back later!
            </h4>
         </div>
      }
   </div>
  <div class="overlay"></div>
</header>

<app-simple-modal title="Social Security Number">
  <p>
    Employees who reside outside the United States and do not possess a U.S. Social
    Security Number should enter their respective government issued Identification Number.<br />
    (U.K. residents use National Insurance #)
  </p>
  <p>
    If you have questions about what number this is or if you have problems accessing
    your Company Stock Plan report, please contact <a href="mailto:cjohnstone@southwestern.com?subject=SWFC Company Stock Plan">Cindy Johnstone</a>.
  </p>
</app-simple-modal>

